export default "__VITE_ASSET__CcBVt7no__"